export const EASY_TRADE_IN_GENCODE = 'RMBC000001';

export const EASY_TRADE_IN_SUB_TYPE = 'swappy';
export const CLASSIC_TRADE_IN_SUB_TYPE = 'classique';

export const EASY_TRADE_IN_SESSION_KEY = 'easy_trade_in_state';

export const EASY_TRADE_IN_FORM_ID = 'easyTradeInChoice';

export const EASY_TRADE_IN_MAX_CREDIT_TO_RECYCLE = 10;

export const EASY_TRADE_IN_REFERENCE_STALE_TIME = 30 * 60 * 1000;
